module.exports = __webpack_public_path__ + "static/img/Bachelor_010241.869bb1c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Bachelor_010241.jpg
// module id = 126
// module chunks = 0